import { render } from "./ZoomOauthCallback.vue?vue&type=template&id=3dfa3968&scoped=true"
import script from "./ZoomOauthCallback.vue?vue&type=script&lang=js"
export * from "./ZoomOauthCallback.vue?vue&type=script&lang=js"

import "./ZoomOauthCallback.vue?vue&type=style&index=0&id=3dfa3968&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-3dfa3968"

export default script